{
  "dashboard-sidebar-support-resources-tooltip": "Click here for answers or to submit a support request.",
  "dashboard-sidebar-support-help-center": "Help Center",
  "dashboard-sidebar-support-getting-started-video": "Getting Started Video",
  "dashboard-sidebar-support-help-button-label": "Help",
  "dashboard-sidebar-support-help-button-unread-count": "Help, {{count}} unread product updates",
  "dashboard-sidebar-support-help-button-unread-count_one": "Help, 1 unread product update",
  "dashboard-sidebar-support-help-button-unread-count_other": "Help, {{count}} unread product updates",
  "dashboard-sidebar-support-whats-new": "What's New",
  "dashboard-sidebar-support-whats-new-unread-count": "{{count}} unread product updates",
  "dashboard-sidebar-support-whats-new-unread-count_one": "1 unread product update",
  "dashboard-sidebar-support-whats-new-unread-count_other": "{{count}} unread product updates",

  "global-search-open": "Open global search",
  "global-search-hide": "Hide global search trigger",
  "global-search-show": "Show global search",
  "global-search-dialog-label": "Global search",
  "global-search-close": "Close search",
  "global-search-input-label": "Search clients, settings, and integrations",
  "global-search-placeholder": "Search clients, settings, integrations",
  "global-search-results-label": "Search results",
  "global-search-section-destinations": "Destinations",
  "global-search-section-clients": "Clients",
  "global-search-account-settings-title": "Account Settings",
  "global-search-account-settings-detail": "Manage your advisor account, email, password, and MFA.",
  "global-search-firm-settings-title": "Firm Settings",
  "global-search-firm-settings-detail": "Manage firm details, team configuration, Elements Labs, and templates.",
  "global-search-integrations-title": "Integrations",
  "global-search-integrations-detail": "Browse available integrations and connection options.",
  "global-search-baa-title": "Morningstar / BAA",
  "global-search-baa-detail": "Open the Morningstar ByAllAccounts integration.",
  "global-search-your-household": "Your household",
  "global-search-client-household": "Client household",
  "global-search-loading-clients": "Loading clients...",
  "global-search-client-error": "Clients could not be loaded. Try again.",
  "global-search-client-partial-error": "Some clients could not be loaded. Try again.",
  "global-search-no-results": "No results found",

  "welcome-modal-title": "Getting Started with Elements",
  "welcome-modal-body": "Welcome to Elements! Watch this video to learn all the basics about how Elements can help you and your clients quickly assess their financial health.",
  "welcome-modal-video-title": "Welcome to Elements",
  "welcome-modal-video-thumbnail-alt": "Getting Started Video Thumbnail",

  "custom-groups-section-title": "Custom Groups",
  "custom-groups-create-modal-title": "New Custom Group",
  "custom-groups-create-name-label": "Group Name",
  "custom-groups-create-name-placeholder": "Required",
  "custom-groups-create-error": "Unable to create custom group",
  "custom-groups-delete-group": "Delete Group",
  "custom-groups-delete-confirmation-title": "Delete “{{- groupName}}” Custom Group?",
  "custom-groups-delete-confirmation-body": "Deleting this group cannot be undone. All clients currently in this group will be unassigned.",
  "custom-groups-delete-confirmation-button": "Delete Custom Group",
  "custom-groups-delete-error": "Unable to delete group",
  "custom-groups-rename-group": "Rename Group",
  "custom-groups-rename-modal-title": "Rename Custom Group",
  "custom-groups-rename-error": "Unable to rename group"
}
